"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _constants = require("../constants");
var _Divider = _interopRequireDefault(require("./Divider.style"));
const _excluded = ["classes", "orientation", "color", "className", "dataTestId"];
var _dec, _class;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let Divider = (_dec = (0, _reactJss.default)(_Divider.default), _dec(_class = class Divider extends _react.PureComponent {
  render() {
    const _this$props = this.props,
      {
        classes,
        orientation,
        color,
        className,
        dataTestId
      } = _this$props,
      props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
    return /*#__PURE__*/_react.default.createElement("hr", (0, _extends2.default)({
      className: (0, _clsx.default)(className, classes.divider, orientation, classes[`backgroundColor__${color}`]),
      "data-testid": dataTestId
    }, props));
  }
}) || _class);
Divider.ORIENTATION = {
  vertical: 'vertical',
  horizontal: 'horizontal'
};
Divider.defaultProps = {
  orientation: Divider.ORIENTATION.vertical
};
Divider.COLOR = _constants.COLOR;
var _default = exports.default = Divider;